import React from "react";
import Page from "../../../components/general/page";
import TSPayAddAccountPage from "../../../components/tspay/account/add";

const TSPayAddAccountView = props => {
  const { isFullscreenOverlay, onClose } = props;
  return (
    <Page isFullscreenOverlay={isFullscreenOverlay}>
      <TSPayAddAccountPage
        onClose={onClose}
        isFullscreenOverlay={isFullscreenOverlay}        
      />
    </Page>
  );
};

export default TSPayAddAccountView;
